import { useTranslation } from "react-i18next";
import { Message } from "primereact/message";

const MapError = () => {
    const { t } = useTranslation();
    return (
        <Message severity="error" text={t("map.errorAccessingData")} closable="false" className="w-full" />
    );
};

export default MapError;
